import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles, LinearProgress, Button, Grid } from "@material-ui/core";
import MapBoxGl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import getRadiusPolygon from "../../Helpers/getRadiusPolygon";
import getChartDrawStyles from "../../Helpers/getChartDrawStyles";
import InfoIcon from "@material-ui/icons/Info";
import ClearIcon from "@material-ui/icons/Clear";
import RefreshIcon from "@material-ui/icons/Refresh";

const useStyles = makeStyles((theme) =>
  createStyles({
    createReportMapContainer: {
      position: "relative",
      height: "calc(100% - 83px)",
      width: "100%",
      background: "#BDBDBD",
      zIndex: "1",
    },
    map: {
      height: "100%",
      width: "100%",
    },
    invisButton: {
      borderRadius: "4px",
      width: "29px",
      height: "29px",
      top: "118px",
      right: "10px",
      zIndex: "1000",
      position: "absolute",
      backgroundColor: "#fff",
      boxShadow: "0 0 0 2px rgb(0 0 0 / 10%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      "&:hover": {
        background: "#ecece9",
      },
    },
    helperBox: {
      padding: "8px",
      boxShadow: "0 0 0 2px rgb(0 0 0 / 10%)",
      borderRadius: "10px",
      width: "200px",
      height: "100px",
      position: "absolute",
      top: "10px",
      right: "50px",
      backgroundColor: "#fff",
      display: "flex",
      justifyContent: "flex-start",
      alignContent: "center",
      flexDirection: "row",
      fontFamily: "nunito",
    },
    clearIcon: {
      display: "flex",
      justifyContent: "flex-end",
    },
    clear: {
      cursor: "pointer",
    },
    drawtool: {
      padding: "0px 0px 9px 9px",
    },
    loadingLocation: {
      paddingTop: "4px",
      overflow: "hidden",
      textAlign: "center",
      position: "absolute",
      top: "0",
      left: "0",
      boxShadow: "0 0 0 2px rgb(0 0 0 / 10%)",
      borderRadius: "4px",
      backgroundColor: "#fff",
      minHeight: "28px",
      maxHeight: "100px",
      width: "240px",
      fontFamily: "nunito",
      fontWeight: "400",
    },
    loadingDiv: {
      minHeight: "10px",
      maxHeight: "100px",
    },
    locationErrorDiv: {
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
    },
    errorSvg: {
      cursor: "pointer",
    },
    refreshBtn: {
      marginLeft: "10px",
      padding: "0px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "0px",
    },
    buttonParent: {
      boxShadow: "0 0 0 2px rgb(0 0 0 / 10%)",
      position: "absolute",
      top: "48px",
      right: "10px",
      borderRadius: "4px",
    },
    deleteDiv: {
      cursor: "pointer",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50%",
      backgroundImage:
        "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggc3R5bGU9Im1hcmtlcjpub25lIiBkPSJNMTAgMy40MTJhMiAyIDAgMDAtMS44MiAxLjE3Nkg1bC0xIDF2MWgxMnYtMWwtMS0xaC0zLjE4QTIgMiAwIDAwMTAgMy40MTJ6TTUgOHY3YzAgMSAxIDIgMiAyaDZjMSAwIDItMSAyLTJWOGgtMnY1LjVoLTEuNVY4aC0zdjUuNUg3Vjh6IiBjb2xvcj0iIzAwMCIgb3ZlcmZsb3c9InZpc2libGUiLz48L3N2Zz4=)",
      zIndex: "2",
      width: "29px",
      height: "29px",
      backgroundColor: "#fff",
      borderBottomRightRadius: "4px",
      borderBottomLeftRadius: "4px",
      "&:hover": {
        backgroundColor: "#f1eeee",
      },
    },
    drawDiv: {
      boxShadow: "0 0 0 0.5px rgb(0 0 0 / 10%)",

      borderBottom: "grey solid 1px",
      cursor: "pointer",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50%",
      backgroundImage:
        "url(data:image/svg+xml;base64,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);",
      zIndex: "2",
      width: "29px",
      height: "29px",
      backgroundColor: "#fff",
      borderTopRightRadius: "4px",
      borderTopLeftRadius: "4px",
      "&:hover": {
        backgroundColor: "#f1eeee",
      },
    },
    clicked: {
      backgroundColor: "#b0d0e6",
    },
  })
);

const CreateReportMap = ({
  setSelectedAnAddress,
  setSelectedNonAddress,
  setFormattedTerm,
  latLng,
  radius,
  setRadius,
  drawnPolygon,
  handlePolygonChange,
  selectedAnAddress,
  selectedNonAddress,
  polygonData,
  editPayload,
  marketReportSubmiting,
  setImageOfMap,
  setLatLng,
  editing,
  setGeoJson,
  setValue,
  loadMap,
  setLoadMap,
  landingPageView,
}) => {
  const classes = useStyles();
  const [mapRef, setMapRef] = useState(null);
  const [markerRef, setMarkerRef] = useState(null);
  const [drawRef, setDrawRef] = useState(null);
  const [helperBox, setHelperBox] = useState(false);
  const [drawClicked, setDrawClicked] = useState(false);
  const [userLocation, setUserLocation] = useState(false);
  const [foundLocation, setFoundLocation] = useState(false);
  const [defaultMapLoaded, setDefaultMapLoaded] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [firstMapLoad, setFirstMapLoad] = useState(false);
  const editPolygon = editPayload?.parameters?.geoJSON?.coordinates[0] ?? false;
  const polygon = polygonData?.polygon?.coords.length > 0 ? polygonData?.polygon?.coords : editPolygon ? editPolygon : [];
  const createMarker = () => {
    let markerElement = document.createElement("div");
    markerElement.innerHTML = `
      <svg width="55" height="55" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M50.2414 89C50.2414 89 77.4828 52.2864 77.4828 37.2414C77.4828 22.1964 65.2864 10 50.2414 10C35.1964 10 23 22.1964 23 37.2414C23 52.2864 50.2414 89 50.2414 89ZM50.2419 50.8603C57.7644 50.8603 63.8626 44.7622 63.8626 37.2397C63.8626 29.7172 57.7644 23.619 50.2419 23.619C42.7194 23.619 36.6212 29.7172 36.6212 37.2397C36.6212 44.7622 42.7194 50.8603 50.2419 50.8603Z" fill="#0079B4"/>
        <circle cx="50" cy="37" r="14" fill="white"/>
      </svg>
    `;
    markerElement.style.display = "none";
    return markerElement;
  };
  const flyToCurrentCenter = () => {
    return mapRef?.flyTo({
      curve: 1,
      speed: 2,
      center: [userLocation[0], userLocation[1]],
    });
  };

  useEffect(() => {
    if (firstMapLoad && userLocation && !landingPageView) {
      flyToCurrentCenter();
    }
  }, [userLocation]);

  useEffect(() => {
    const handleDrawChange = (e, draw, marker, map) => {
      setDrawClicked(false);
      const data = draw.getAll();
      if (data?.features.length > 0) {
        const unwantedPolygons = data?.features?.map((feat, i) => {
          if (i > 0) {
            return feat.id;
          }
          return null;
        });
        draw.delete(unwantedPolygons);
      }
      let newPolygon;
      setGeoJson(data.features[0]?.geometry);
      if (data?.features[0]?.geometry?.coordinates.length === 1) {
        newPolygon = data?.features[0]?.geometry?.coordinates[0] ?? [];
      } else {
        newPolygon = data?.features[0]?.geometry?.coordinates ?? [];
      }
      const markerDiv = marker?.getElement();
      markerDiv.style.display = "none";
      if (map.getLayer("markerRadiusPolygonStyles")) {
        map.removeLayer("markerRadiusPolygonStyles");
      }
      if (map.getSource("markerRadiusPolygon")) {
        map.removeSource("markerRadiusPolygon");
      }
      const center = map.getCenter();
      setLatLng(center);
      setRadius(0);
      handlePolygonChange(newPolygon);
    };

    MapBoxGl.accessToken = "pk.eyJ1IjoiYmx1ZXJvb2YzNjAiLCJhIjoiY2prOHB1am40MDNlYjNwczBtN3V6ZG01dCJ9.IPRccV7flof-4CpZIbgcqg";
    const map = new MapBoxGl.Map({
      container: "createReportMapContainer",
      center: userLocation ? userLocation : [-122.479005, 48.752558],
      zoom: 11,
      style: "mapbox://styles/mapbox/light-v11?fresh=true&optimize=true",
      hash: false,
      attributionControl: false,
      preserveDrawingBuffer: true,
    });
    map.addControl(new MapBoxGl.AttributionControl(), "bottom-right");
    map.addControl(
      new MapBoxGl.ScaleControl({
        maxWidth: 150,
        unit: "imperial",
      }),
      "bottom-right"
    );
    map.addControl(
      new MapBoxGl.NavigationControl({
        zoomIn: true,
        zoomOut: true,
      }),
      "bottom-right"
    );

    map.addControl(
      new MapBoxGl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );

    if (map.getLayer("markerRadiusPolygonStyles")) {
      map.removeLayer("markerRadiusPolygonStyles");
    }
    if (map.getSource("markerRadiusPolygon")) {
      map.removeSource("markerRadiusPolygon");
    }

    const marker = new MapBoxGl.Marker({
      element: createMarker(),
    });

    const draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true,
      },
      styles: getChartDrawStyles(),
    });
    map.addControl(draw);

    marker.setLngLat([-122.479005, 48.752558]);
    marker.addTo(map);

    const center = [-122.479005, 48.752558];
    map.on("load", () => {
      if (!map.getSource("markerRadiusPolygon")) {
        map.addSource("markerRadiusPolygon", getRadiusPolygon(center, 0));
      }
      if (!map.getLayer("markerRadiusPolygonStyles")) {
        map.addLayer({
          id: "markerRadiusPolygonStyles",
          type: "fill",
          source: "markerRadiusPolygon",
          layout: {},
          paint: {
            "fill-color": `#0079B4`,
            "fill-opacity": 0.2,
          },
        });
      }
    });

    map.on("style.load", () => {
      setDefaultMapLoaded(true);
    });

    map.on("draw.create", (e) => handleDrawChange(e, draw, marker, map));
    map.on("draw.delete", (e) => handleDrawChange(e, draw, marker, map));
    map.on("draw.update", (e) => handleDrawChange(e, draw, marker, map));

    setMapRef(map);
    setMarkerRef(marker);
    setDrawRef(draw);
    setFirstMapLoad(true);
    return () => {
      setDefaultMapLoaded(false);
    };
  }, []);
  useEffect(() => {
    if (mapRef !== null && drawRef !== null && editPayload && loadMap) {
      if (editing && !selectedNonAddress && !selectedAnAddress && editPayload?.parameters?.geoJSON?.coordinates[0]) {
        setLoadMap(false);
        const feature = {
          id: "edited-drawn-polygon",
          type: "Feature",
          properties: {},
          geometry: {
            coordinates: [editPayload?.parameters?.geoJSON?.coordinates[0] ?? []],
            type: "Polygon",
          },
        };
        drawRef.add(feature);
      }
    }
  }, [editing, selectedAnAddress, selectedNonAddress, editPayload, mapRef, drawRef, loadMap]);

  const error = (err) => {
    setLocationError(err.message);
  };
  const getUserLocationAttempt = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setFoundLocation(true);
        setUserLocation([position.coords.longitude, position.coords.latitude]);
      },
      error,
      { timeout: 10000 }
    );
  };

  useEffect(() => {
    if (navigator.geolocation && !editing) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setFoundLocation(true);
          setUserLocation([position.coords.longitude, position.coords.latitude]);
        },
        error,
        { timeout: 10000 }
      );
    }
  }, [editing]);

  const flyToCenter = () => {
    return mapRef?.flyTo({
      center: [latLng.lng, latLng.lat],
    });
  };

  const updateMarkerLocation = () => {
    const markerDiv = markerRef?.getElement();
    markerDiv.style.display = "block";
    return markerRef?.setLngLat([latLng.lng, latLng.lat]);
  };

  useEffect(() => {
    if (mapRef !== null && markerRef !== null) {
      flyToCenter();
      updateMarkerLocation();
    }
  }, [latLng]);

  useEffect(() => {
    if (selectedAnAddress && mapRef !== null) {
      const handleMapLoad = () => {
        const center = [latLng.lng, latLng.lat];
        if (mapRef.getLayer("markerRadiusPolygonStyles")) {
          mapRef.removeLayer("markerRadiusPolygonStyles");
        }
        if (mapRef.getSource("markerRadiusPolygon")) {
          mapRef.removeSource("markerRadiusPolygon");
        }
        mapRef.addSource("markerRadiusPolygon", getRadiusPolygon(center, radius));
        mapRef.addLayer({
          id: "markerRadiusPolygonStyles",
          type: "fill",
          source: "markerRadiusPolygon",
          layout: {},
          paint: {
            "fill-color": "#0079B4",
            "fill-opacity": 0.2,
            "fill-antialias": true,
            "fill-outline-color": "#0079B4",
          },
        });
      };

      if (defaultMapLoaded) {
        handleMapLoad();
      }
    } else if (selectedNonAddress && mapRef !== null) {
      const handleMapLoad = () => {
        if (mapRef.getLayer("markerRadiusPolygonStyles")) {
          mapRef.removeLayer("markerRadiusPolygonStyles");
        }
        if (mapRef.getSource("markerRadiusPolygon")) {
          mapRef.removeSource("markerRadiusPolygon");
        }
        mapRef.addSource("markerRadiusPolygon", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [polygon],
            },
          },
        });
        mapRef.addLayer({
          id: "markerRadiusPolygonStyles",
          type: "fill",
          source: "markerRadiusPolygon",
          layout: {},
          paint: {
            "fill-color": "#0079B4",
            "fill-opacity": 0.2,
            "fill-antialias": true,
            "fill-outline-color": "#0079B4",
          },
        });
      };

      if (defaultMapLoaded) {
        handleMapLoad();
      }
    } else {
      if (mapRef !== null && markerRef !== null) {
        const markerDiv = markerRef?.getElement();
        markerDiv.style.display = "none";
        if (mapRef.getLayer("markerRadiusPolygonStyles")) {
          mapRef.removeLayer("markerRadiusPolygonStyles");
        }
        if (mapRef.getSource("markerRadiusPolygon")) {
          mapRef.removeSource("markerRadiusPolygon");
        }
      }
    }
  }, [radius, selectedAnAddress, selectedNonAddress, polygonData, latLng, mapRef, defaultMapLoaded]);

  const deletePolygon = () => {
    return drawRef?.deleteAll();
  };

  const deletePolygonClick = () => {
    setSelectedAnAddress(false);
    setSelectedNonAddress(false);
    setFormattedTerm({
      city: "",
      state: "",
      county: "",
      zip: "",
      neighborhood: "",
    });
    setValue("", false);
    return drawRef?.deleteAll();
  };

  useEffect(() => {
    if (!drawnPolygon) {
      deletePolygon();
    }
  }, [drawnPolygon]);

  useEffect(() => {
    if (marketReportSubmiting && mapRef !== null) {
      const img = mapRef.getCanvas().toDataURL();
      setImageOfMap(img);
    }
  }, [marketReportSubmiting]);
  const clickDrawDiv = () => {
    var x = document.getElementsByClassName("mapbox-gl-draw_polygon");
    x[0].click();
  };
  return (
    <Grid item sm={12} md={6} lg={8} className={classes.createReportMapContainer}>
      <div id="createReportMapContainer" className={classes.map} />
      <div
        onClick={() => {
          setHelperBox(!helperBox);
        }}
        className={classes.invisButton}
      >
        <InfoIcon style={{ fontSize: "24px" }} />
      </div>
      {helperBox ? (
        <div className={classes.helperBox}>
          <div className={classes.drawtool}>When using the draw tool, double click on a previous point you've made to end the draw.</div>
          <div className={classes.clearIcon}>
            <ClearIcon
              className={classes.clear}
              onClick={() => {
                setHelperBox(!helperBox);
              }}
            />
          </div>
        </div>
      ) : null}
      {foundLocation || editing || landingPageView ? null : (
        <div className={classes.loadingLocation}>
          <div className={classes.loadingDiv}>
            {locationError ? (
              <div className={classes.locationErrorDiv}>
                {locationError}
                <Button
                  className={classes.refreshBtn}
                  onClick={() => {
                    setLocationError(false);
                    getUserLocationAttempt();
                  }}
                  title="Try Again"
                >
                  <RefreshIcon className={classes.errorSvg} />
                </Button>
              </div>
            ) : (
              "Getting Your Current Location..."
            )}
          </div>
          {locationError ? null : <LinearProgress color="primary" />}
        </div>
      )}
      <div className={classes.buttonParent}>
        <div
          className={`${classes.drawDiv} ${drawClicked ? classes.clicked : null}`}
          onClick={() => {
            clickDrawDiv();
            setDrawClicked(!drawClicked);
          }}
        ></div>
        <div
          className={classes.deleteDiv}
          onClick={() => {
            deletePolygonClick();
          }}
        ></div>
      </div>
    </Grid>
  );
};

CreateReportMap.propTypes = {
  setValue: PropTypes.func,
  setSelectedAnAddress: PropTypes.func,
  setSelectedNonAddress: PropTypes.func,
  setFormattedTerm: PropTypes.func,
  setGeoJson: PropTypes.func,
  latLng: PropTypes.object,
  radius: PropTypes.number,
  selectedAnAddress: PropTypes.bool,
  selectedNonAddress: PropTypes.bool,
  polygonData: PropTypes.object,
  drawnPolygon: PropTypes.any,
  marketReportSubmiting: PropTypes.bool,
  setImageOfMap: PropTypes.func,
  loadMap: PropTypes.bool,
  setLoadMap: PropTypes.func,
  setLatLng: PropTypes.func,
  landingPageView: PropTypes.bool,
};

export default CreateReportMap;
